export default [
  {
    path: "/orderSubmit",
    name: "orderSubmit",
    component: () => import("@parent/views/order/submit.vue"),
  },
  {
    path: "/payResult",
    name: "payResult",
    component: () => import("@parent/views/order/pay-result.vue"),
  },
  {
    path: "/orderList",
    name: "orderList",
    component: () => import("@parent/views/order/list/list.vue"),
  },
  {
    path: "/orderDetail/:id/:orderType/:sourceType",
    name: "orderDetail",
    component: () => import("@parent/views/order/detail/detail.vue"),
  },
  {
    path: "/receipt",
    name: "receipt",
    component: () => import("@teacher/views/sf/receipt-new.vue"),
  },
  {
    path: "/contractPreview",
    name: "contractPreview",
    component: () => import("@parent/views/order/contract-preview.vue"),
  }
];
